import styled from 'styled-components'
import measures from 'globals/measures'
import colors from 'globals/colors'

export const ButtonWrapper = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    @media (max-width: ${measures.mobileThreshold}px) {
        flex-basis: 100%;

        & > button {
            width: 100%;
            margin-top: 28px;
        }
    }
}
`

export const WarningFreeAnswer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    padding: 12px;
    border-radius: 8px;
    border: 1px solid ${colors.borderBaseColor};
    background-color: ${colors.gold};

    .confirm-no-answer-checkbox {
        gap: 16px;
        font-weight: bold;
    }

    & > p {
        margin: 0;
    }
`

export const FreeAnswerModalButtonWrapper = styled.div`
    display: flex;
    justify-content: space-between
`

export const ListWrapper = styled.div`
    margin-top: 50px;
`

export const ErrorBox = styled.p`
    color: ${colors.reddishPink}
`
